<template>
  <div>
    <v-chip v-if="!delivered" color="orange" text-color="white">
      <v-avatar left>
        <v-icon>mdi-alert-circle</v-icon>
      </v-avatar>
      Ikke levert
    </v-chip>

    <v-chip v-if="delivered" color="green" text-color="white">
      <v-avatar left>
        <v-icon>mdi-checkbox-marked-circle</v-icon>
      </v-avatar>
      Levert
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "OrderDelivered",
  props: {
    delivered: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
